import { render, staticRenderFns } from "./LoadingContent.vue?vue&type=template&id=f9056db8&scoped=true"
import script from "./LoadingContent.vue?vue&type=script&lang=js"
export * from "./LoadingContent.vue?vue&type=script&lang=js"
import style0 from "./LoadingContent.vue?vue&type=style&index=0&id=f9056db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9056db8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingContent.vue
// module id = 545
// module chunks = 31